/*
 * VOITKUS Brew — guided brew timer (sections/brew-timer.liquid).
 * Recipes and coffees come from <script type="application/json" data-brew-data> (snippets/brew-data.liquid).
 * Brew history is kept only in this browser (localStorage 'vk-brew-history').
 * URL: ?coffee=<product-handle>&recipe=<recipe-handle>&start=1 | #submit-recipe
 */
(() => {
  'use strict';

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const toSec = (v) => { const m = String(v || '').trim().match(/^(\d+):(\d{1,2})$/); return m ? (+m[1]) * 60 + (+m[2]) : NaN; };

  function init(root) {
    if (!root || root.hasAttribute('data-brew-ready')) return;
    const dataEl = (root.parentElement || document).querySelector('[data-brew-data]');
    if (!dataEl) return;
    root.setAttribute('data-brew-ready', '');

    const $ = (s) => root.querySelector(s), $$ = (s) => [...root.querySelectorAll(s)];
    const DATA = JSON.parse(dataEl.textContent);
    const isCom = (r) => !!(r && (r.community || (r.author && String(r.author).toUpperCase() !== 'VOITKUS')));
    const SPECIALTY_AUTHORS = ['Arc Co Coffee Roastery', 'Nas Jaafar'];
    const isSpecialty = (r) => !!(r && r.author && SPECIALTY_AUTHORS.includes(r.author));
    const isCommunity = (r) => isCom(r) && !isSpecialty(r);
    const mill = (r) => [r.grinder, r.setting].filter(Boolean).join(' ') || r.grind || '';
    const specLine = (r) => [r.method, r.dose + ' g → ' + r.water + ' g', r.temp + '°C', mill(r)].filter(Boolean).join(' · ');
    function parseOne(r) {
      if (!r) return null;
      const rec = {
        id: r.id, name: r.name, author: r.author || 'VOITKUS', method: r.method || '',
        dose: r.dose, water: r.water, temp: r.temp, grind: r.grind || '',
        grinder: r.grinder, setting: r.setting, tmin: r.tmin || '', tmax: r.tmax || '',
        taste: r.taste || '', instagram: r.instagram || '', community: !!r.community,
        steps: String(r.steps || '').split(/\n/).map((l) => l.split('|').map((x) => x.trim())).filter((p) => p.length >= 2 && !isNaN(toSec(p[0])))
          .map((p) => [toSec(p[0]), p[1].toLowerCase(), p[2] ? parseFloat(p[2].replace(',', '.')) : null, p[3] || ''])
      };
      return rec.steps.some((s) => s[1] === 'finish') ? rec : null;
    }
    const RECIPES = DATA.recipes.map(parseOne).filter(Boolean);
    const COFFEES = DATA.coffees;
    if (!RECIPES.length) { ($('.vkb__body') || root).innerHTML = '<p class="vk-section-head__note">Brak przepisów. Dodaj je w Treści → Metaobiekty → Przepis.</p>'; return; }
    const qs = new URLSearchParams(location.search);
    let coffee = COFFEES.find((c) => c.id === qs.get('coffee')) || COFFEES[0] || { id: '', name: 'Twoja kawa', c: 'var(--lot-orange)', price: '', url: '#', recipes: [] };
    // Baza przepisów jest wspólna: każdy przepis (Palarnia + Brew Community) da się zaparzyć
    // z dowolną kawą. Powiązanie kawa→przepis w polu produktu ('Przepisy (Brew)') decyduje
    // wyłącznie o tym, który przepis pokazuje się jako polecany w kafelku 'Jak zaparzyć' na
    // karcie produktu — tu, w Brew Timerze, jest tylko domyślną podpowiedzią przy starcie.
    const preferredFor = (c) => {
      const ids = c.recipes || [];
      const linked = ids.map((h) => RECIPES.find((r) => r.id === h)).filter(Boolean);
      return linked[0] || RECIPES[0] || null;
    };
    let recipe = RECIPES.find((r) => r.id === qs.get('recipe')) || preferredFor(coffee);
    const fmt = (s) => { s = Math.max(0, Math.floor(s)); return String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0'); };

    // Stages derived from steps: each step lasts until the next one; the gap after the last pour is the draw-down.
    function stages(r) {
      const out = []; let pours = 0;
      r.steps.forEach((step, i) => {
        const [time, type, g, note] = step; const end = r.steps[i + 1] ? r.steps[i + 1][0] : null;
        if (type === 'finish') return;
        let label, short, action, sub = '', bloom = false;
        if (type === 'pour') {
          pours++;
          bloom = /^bloom$/i.test(note);
          const n = pours - (r.steps.some((s) => /^bloom$/i.test(s[3])) ? 1 : 0);
          label = bloom ? 'Bloom' : 'Pour ' + n;
          short = bloom ? 'B' : String(n);
          action = 'Nalej do ' + g + ' g';
          sub = bloom ? 'Zwilż całą kawę i odczekaj' : 'Lej spokojnie, spiralą od środka';
        } else if (type === 'close') { label = 'Prep'; short = 'P'; action = 'Zamknij zawór'; sub = 'Kawa w dripperze, zawór zamknięty'; }
        else if (type === 'open') { label = 'Drawdown'; short = 'D'; action = 'Otwórz zawór'; sub = 'Pozwól kawie spłynąć'; }
        out.push({ t: time, end, type, g, label, short, action, sub, bloom });
      });
      // After the last pour: explicit draw-down stage until finish.
      const lastStage = out[out.length - 1];
      if (lastStage && lastStage.type === 'pour') {
        const fin = r.steps.find((s) => s[1] === 'finish');
        const drawFrom = lastStage.t + Math.min(20, (fin[0] - lastStage.t) / 3);
        lastStage.end = drawFrom;
        out.push({ t: drawFrom, end: fin[0], type: 'draw', label: 'Drawdown', short: 'D', action: 'Czekaj, kawa spływa', sub: 'Cel: ' + r.tmin + '–' + r.tmax, bloom: false });
      }
      const stopFrom = finishAt(r), stop = endAt(r);
      if (stop > stopFrom) out.push({ t: stopFrom, end: stop, type: 'end', label: 'Finish', short: 'F', action: 'Zdejmij dripper, gdy przestanie kapać', sub: 'Potem naciśnij GOTOWE', bloom: false });
      return out;
    }
    const finishAt = (r) => r.steps.find((s) => s[1] === 'finish')[0];
    const endAt = (r) => { const x = toSec(r.tmax); return isNaN(x) ? finishAt(r) : Math.max(finishAt(r), x); };

    // ---------- pick ----------
    let shownHouse = 5, shownCom = 5;
    const SHOW_STEP = 20;
    const METHOD_LABELS = { origami: 'Origami', v60: 'V60', switch: 'Switch', chemex: 'Chemex', aeropress: 'AeroPress', kalita: 'Kalita', inna: 'Inna' };
    const methodLabel = (m) => METHOD_LABELS[m] || (m ? m.charAt(0).toUpperCase() + m.slice(1) : 'Inna');
    let methodFilter = 'all';
    function renderMethodFilters() {
      const el = $('#methodFilters');
      if (!el) return;
      const present = [...new Set(RECIPES.map((r) => r.method).filter(Boolean))];
      const hasCom = RECIPES.some(isCommunity);
      const hasSpecialty = RECIPES.some(isSpecialty);
      if (present.length < 2 && !hasCom && !hasSpecialty) { el.innerHTML = ''; return; }
      const chip = (val, label, extra) => '<button type="button" class="vk-chip mf-chip' + (extra || '') + '" data-mf="' + esc(val) + '" aria-pressed="' + (methodFilter === val) + '">' + esc(label) + '</button>';
      el.innerHTML = chip('all', 'Wszystkie')
        + (present.length >= 2 ? present.map((m) => chip(m, methodLabel(m))).join('') : '')
        + (hasSpecialty ? chip('specialty', 'Specialty world', ' mf-chip--sw') : '')
        + (hasCom ? chip('community', 'Brew Community', ' mf-chip--com') : '');
      $$('[data-mf]').forEach((b) => b.addEventListener('click', () => { methodFilter = b.dataset.mf; shownHouse = 5; shownCom = 5; renderPick(); }));
    }
    function renderPick() {
      renderMethodFilters();
      const list = methodFilter === 'all' ? RECIPES
        : methodFilter === 'community' ? RECIPES.filter(isCommunity)
        : methodFilter === 'specialty' ? RECIPES.filter(isSpecialty)
        : RECIPES.filter((r) => r.method === methodFilter);
      $('#coffees').innerHTML = COFFEES.map((c) => '<button type="button" class="vk-chip cof" data-c="' + esc(c.id) + '" style="--c:' + esc(c.c) + '" aria-pressed="' + (c === coffee) + '"><i></i>' + esc(c.name) + '</button>').join('');
      $$('[data-c]').forEach((b) => b.addEventListener('click', () => { coffee = COFFEES.find((c) => c.id === b.dataset.c); shownHouse = 5; shownCom = 5; renderPick(); }));
      const house = list.filter((r) => !isCom(r));
      const specialty = list.filter(isSpecialty);
      const guests = list.filter(isCommunity);
      const linkedIds = coffee.recipes || [];
      const recId = linkedIds.length ? (linkedIds.map((h) => RECIPES.find((r) => r.id === h)).filter(Boolean)[0] || {}).id : null;
      const card = (r) => {
        const isRec = r.id && r.id === recId;
        const badge = isRec ? '<span class="rec-badge">Polecany dla tej kawy</span>' : '';
        const mini = stages(r).map((s) => '<span class="' + (s.bloom ? 'b' : s.type === 'pour' ? 'p' : '') + '" style="--w:' + Math.max(1, s.end - s.t) + '"></span>').join('');
        const ig = r.instagram ? ' · ' + esc(r.instagram) : '';
        const who = isSpecialty(r)
          ? '<span class="who">Specialty world · ' + esc(r.author) + ig + '</span>'
          : isCom(r)
          ? '<span class="who">Brew Community · ' + esc(r.author) + ig + '</span>'
          : '';
        const cup = r.taste ? '<span class="cup vk-card__text">' + esc(r.taste) + '</span>' : '';
        return '<button type="button" class="vk-card rc' + (isCom(r) ? ' rc--com' : '') + (isRec ? ' rc--rec' : '') + '" data-r="' + esc(r.id) + '" aria-pressed="' + (r === recipe) + '">' + badge + '<div>' + who + '<b class="vk-card__title">' + esc(r.name) + '</b></div><span class="time"><strong>' + esc(r.tmin) + '</strong>do ' + esc(r.tmax) + '</span><span class="spec">' + esc(specLine(r)) + '</span>' + cup + '<span class="mini">' + mini + '</span></button>';
      };
      let html = '';
      if (house.length && (specialty.length || guests.length)) html += '<p class="vk-eyebrow">VOITKUS</p>';
      html += house.slice(0, shownHouse).map(card).join('');
      if (house.length > shownHouse) html += '<button type="button" class="vk-btn vk-btn--secondary vk-btn--sm" data-more="house">Pokaż więcej (' + (house.length - shownHouse) + ') \u2192</button>';
      if (specialty.length) {
        html += '<p class="vk-eyebrow">Specialty world</p>' + specialty.map(card).join('');
      }
      if (guests.length) {
        html += '<p class="vk-eyebrow">Brew Community</p>' + guests.slice(0, shownCom).map(card).join('');
        if (guests.length > shownCom) html += '<button type="button" class="vk-btn vk-btn--secondary vk-btn--sm" data-more="com">Pokaż więcej (' + (guests.length - shownCom) + ') \u2192</button>';
      }
      $('#recipes').innerHTML = html || '<p class="note" style="text-align:left">Brak przepisów dla tej metody.</p>';
      $$('[data-r]').forEach((b) => b.addEventListener('click', () => { recipe = RECIPES.find((r) => r.id === b.dataset.r); renderPick(); }));
      $$('[data-more]').forEach((b) => b.addEventListener('click', () => { if (b.dataset.more === 'house') shownHouse += SHOW_STEP; else shownCom += SHOW_STEP; renderPick(); }));
      $('#toTimer').disabled = !recipe;
      root.style.setProperty('--acc', coffee.c);
    }

    // ---------- timer ----------
    let again = null;
    let st = [], t = 0, running = false, raf = 0, last = 0, stageIdx = -1, speed = 1, sound = true, wakeLock = null, audio = null;
    const beep = (f = 880, d = .14) => {
      if (!sound) return;
      try {
        audio = audio || new (window.AudioContext || window.webkitAudioContext)();
        const o = audio.createOscillator(), g = audio.createGain();
        o.frequency.value = f; o.connect(g); g.connect(audio.destination);
        g.gain.setValueAtTime(.001, audio.currentTime); g.gain.exponentialRampToValueAtTime(.25, audio.currentTime + .02); g.gain.exponentialRampToValueAtTime(.001, audio.currentTime + d);
        o.start(); o.stop(audio.currentTime + d + .02);
      } catch (e) { /* audio unavailable — vibration below still works */ }
      if (navigator.vibrate) navigator.vibrate(120);
    };
    async function keepAwake(on) {
      try {
        if (on && 'wakeLock' in navigator) { wakeLock = await navigator.wakeLock.request('screen'); $('#wake').textContent = 'Ekran nie zgaśnie'; }
        else if (on) { $('#wake').textContent = 'Ekran może zgasnąć — dotknij go od czasu do czasu'; }
        else if (wakeLock) { await wakeLock.release(); wakeLock = null; $('#wake').textContent = ''; }
      } catch (e) { $('#wake').textContent = 'Ekran może zgasnąć — dotknij go od czasu do czasu'; }
    }
    // The recipe proposal section (#submit-recipe) sits below the app column and is shown only with the pick screen.
    const showPick = (on) => { $('#pick').hidden = !on; const sub = $('#submit-recipe'); if (sub) sub.hidden = !on; };
    function openTimer() {
      if (!recipe) return;
      st = stages(recipe); t = 0; stageIdx = -1; running = false;
      showPick(false); $('#done').hidden = true; $('#timer').hidden = false;
      $('#tbCoffee').innerHTML = '<span style="display:inline-block;width:9px;height:9px;border-radius:50%;background:' + esc(coffee.c) + ';margin-right:8px"></span>' + esc(coffee.name);
      $('#tbSpec').textContent = (isCom(recipe) ? recipe.author + ' · ' : '') + recipe.name + ' · ' + recipe.dose + '/' + recipe.water + ' · ' + recipe.temp + '°C';
      $('#tl').innerHTML = st.map((s, i) => '<div class="seg" data-i="' + i + '" style="--w:' + Math.max(1, s.end - s.t) + ';--k:' + esc(s.bloom ? coffee.c : 'var(--color-ink)') + '"><i></i><span title="' + esc(s.label) + '">' + esc(s.label) + '</span></div>').join('');
      $$('.seg span').forEach((el, i) => { if (el.scrollWidth > el.clientWidth) el.textContent = st[i].short; });
      $('#lbl').textContent = 'Gotowy?';
      $('#do').innerHTML = 'Nastaw wagę na zero<small>' + esc(recipe.dose) + ' g kawy' + (mill(recipe) ? ', ' + esc(mill(recipe)) : '') + ', woda ' + esc(recipe.temp) + '°C</small>';
      $('#next').innerHTML = 'Pierwszy krok: <b>' + esc(st[0].action.toLowerCase()) + '</b>. Naciśnij START, gdy zaczynasz.';
      $('#clock').textContent = '00:00'; $('#stepFill').style.width = '0%';
      setGo(); $('#timer').scrollIntoView({ block: 'start' });
    }
    const inEnd = () => !!(st[stageIdx] && st[stageIdx].type === 'end');
    function setGo() {
      const g = $('#go');
      g.textContent = inEnd() ? 'GOTOWE' : running ? 'PAUZA' : (t > 0 ? 'WZNÓW' : 'START');
      g.classList.toggle('pause', running && !inEnd());
    }
    function tick(now) {
      if (!running) return;
      t += (now - last) / 1000 * speed; last = now;
      const stop = endAt(recipe);
      if (t >= stop) { t = stop; render(); finish(); return; }
      render(); raf = requestAnimationFrame(tick);
    }
    function render() {
      $('#clock').textContent = fmt(t);
      let i = st.findIndex((s) => t >= s.t && t < s.end); if (i < 0) i = st.length - 1;
      if (i !== stageIdx) {
        stageIdx = i; const s = st[i];
        // #lbl and #do sit in the .stage live region: they change once per stage, never per frame.
        $('#lbl').textContent = s.label;
        $('#do').innerHTML = esc(s.action) + '<small>' + esc(s.sub) + '</small>';
        const n = st[i + 1];
        $('#next').innerHTML = n ? 'Dalej: <b>' + esc(n.action.toLowerCase()) + '</b> o ' + fmt(n.t) : 'Dalej: <b>koniec</b> ok. ' + esc(recipe.tmin) + '–' + esc(recipe.tmax);
        if (t > 0.2) { beep(s.type === 'draw' ? 660 : 880); $('#timer').classList.remove('flash'); void $('#timer').offsetWidth; $('#timer').classList.add('flash'); }
        $$('.seg').forEach((el, k) => el.classList.toggle('on', k === i));
        setGo();
      }
      const s = st[stageIdx];
      $('#stepFill').style.width = Math.min(100, (t - s.t) / Math.max(1, s.end - s.t) * 100) + '%';
      $$('.seg').forEach((el, k) => { const x = st[k]; el.style.setProperty('--f', Math.min(100, Math.max(0, (t - x.t) / Math.max(1, x.end - x.t) * 100)) + '%'); });
    }
    function toggle() {
      if (inEnd()) { finish(); return; }
      if (!running) { running = true; last = performance.now(); keepAwake(true); if (t === 0) beep(1040); raf = requestAnimationFrame(tick); }
      else { running = false; cancelAnimationFrame(raf); }
      setGo();
    }
    const track = (name, data) => { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) { /* analytics must never break the timer */ } };
    function finish() {
      track('vk_brew_completed', { coffee: coffee.id, recipe: recipe.id, seconds: Math.round(t) });
      running = false; cancelAnimationFrame(raf); keepAwake(false); beep(1200, .3); setTimeout(() => beep(1200, .3), 350);
      $('#timer').hidden = true; $('#done').hidden = false; $('#result').hidden = true;
      $('#doneLead').textContent = (isCom(recipe) ? recipe.author + ' · ' : '') + recipe.name + ' · ' + coffee.name + ' · ' + fmt(t) + '. Trzy suwaki i gotowe.';
      again = null;
      $$('[data-again]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
      ['ac', 'sw', 'st'].forEach((id) => { $('#' + id).value = 3; $('#' + id + 'V').textContent = WORD[2]; });
      $('#done').scrollIntoView({ block: 'start' });
    }

    // ---------- feedback ----------
    const WORD = ['za mało', 'trochę mało', 'w sam raz', 'trochę dużo', 'za dużo'];
    ['ac', 'sw', 'st'].forEach((id) => $('#' + id).addEventListener('input', (e) => { $('#' + id + 'V').textContent = WORD[e.target.value - 1]; }));
    $$('[data-again]').forEach((b) => b.addEventListener('click', () => { again = b.dataset.again === '1'; $$('[data-again]').forEach((x) => x.setAttribute('aria-pressed', x === b)); }));
    function tipsFor(ac, sw, stv) {
      if (ac >= 4 && sw <= 2) return [['Kwaśno i płasko?', 'Zmiel o jeden stopień drobniej. Resztę zostaw.']];
      if (ac <= 2 && stv >= 4) return [['Gorzko i ciężko?', 'Zmiel o jeden stopień grubiej. Resztę zostaw.']];
      if (stv >= 4) return [['Za mocno?', 'Dolej 10–15 g wody więcej. Mielenie zostaw.']];
      if (stv <= 2) return [['Za słabo?', 'Nalej 10–15 g wody mniej. Mielenie zostaw.']];
      if (sw <= 2) return [['Mało słodyczy?', 'Zmiel o jeden stopień drobniej. Resztę zostaw.']];
      return [['Trafione.', 'Ten przepis pasuje do tej kawy. Zaparz tak samo następnym razem.']];
    }
    const KEY = 'vk-brew-history';
    const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    $('#save').addEventListener('click', () => {
      const ac = +$('#ac').value, sw = +$('#sw').value, stv = +$('#st').value;
      const h = load(); h.push({ c: coffee.id, r: recipe.id, ac, sw, st: stv, again, at: Date.now() });
      track('vk_brew_rated', { coffee: coffee.id, recipe: recipe.id, acidity: ac, sweetness: sw, strength: stv, again: again });
      try { localStorage.setItem(KEY, JSON.stringify(h)); } catch (e) { /* private mode / storage full: history is optional */ }
      $('#tips').innerHTML = tipsFor(ac, sw, stv).map(([a, b]) => '<div class="vk-card"><p class="vk-card__title">' + esc(a) + '</p><p class="vk-card__text">' + esc(b) + '</p></div>').join('');
      const mine = h.filter((x) => x.c === coffee.id);
      const score = {}; mine.forEach((x) => { if (x.again === true) score[x.r] = (score[x.r] || 0) + 1; });
      const favId = Object.keys(score).sort((a, b) => score[b] - score[a])[0];
      const fav = RECIPES.find((r) => r.id === favId);
      $('#count').textContent = mine.length;
      $('#fav').textContent = fav ? fav.name + ' · ' + fav.dose + '/' + fav.water + ' · ' + fav.temp + '°C' : '—';
      $('#buyName').textContent = coffee.name + (coffee.price ? ' · ' + coffee.price : '');
      $('#buyLink').href = coffee.url || '#';
      $('#result').hidden = false; $('#result').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });

    // ---------- wiring ----------
    $('#toTimer').addEventListener('click', openTimer);
    $('#go').addEventListener('click', toggle);
    $('#reset').addEventListener('click', () => { running = false; cancelAnimationFrame(raf); keepAwake(false); openTimer(); });
    $('#back').addEventListener('click', () => { running = false; cancelAnimationFrame(raf); keepAwake(false); $('#timer').hidden = true; showPick(true); });
    $('#again').addEventListener('click', openTimer);
    $('#sound').addEventListener('click', (e) => { sound = !sound; e.target.setAttribute('aria-pressed', sound); e.target.textContent = 'Dźwięk: ' + (sound ? 'wł.' : 'wył.'); });
    $('#demo').addEventListener('click', (e) => { speed = speed === 1 ? 10 : 1; e.target.setAttribute('aria-pressed', speed > 1); });
    document.addEventListener('visibilitychange', () => { if (!document.hidden && running) keepAwake(true); });

    // ---------- Brew Community submission ----------
    const coffeeSel = $('#sCoffee');
    if (coffeeSel) {
      coffeeSel.innerHTML = '<option value="">Wybierz</option>' + COFFEES.map((c) => '<option value="' + esc(c.id) + '">' + esc(c.name) + '</option>').join('');
      if (coffee && coffee.id) coffeeSel.value = coffee.id;
    }
    const openSubmit = (on) => {
      const btn = $('#submitToggle'), panel = $('#submitPanel');
      if (!btn || !panel) return;
      const open = on == null ? btn.getAttribute('aria-expanded') !== 'true' : !!on;
      btn.setAttribute('aria-expanded', open);
      panel.hidden = !open;
    };
    const submitToggle = $('#submitToggle');
    if (submitToggle) submitToggle.addEventListener('click', () => openSubmit());
    if ($('#submitPanel .submit__ok') || $('#submitPanel .submit__err')) openSubmit(true);
    const brewForm = $('#brew-submit');
    if (brewForm) {
      brewForm.addEventListener('submit', (e) => {
        const err = $('#sErr');
        const p1t = ($('#sP1T') || {}).value || '', p2t = ($('#sP2T') || {}).value || '', fin = ($('#sFin') || {}).value || '';
        const t1 = toSec(p1t), t2 = toSec(p2t), tf = toSec(fin);
        const bloomG = +(($('#sBloomG') || {}).value || 0), p1g = +(($('#sP1G') || {}).value || 0), water = +(($('#sWater') || {}).value || 0);
        if (isNaN(t1) || isNaN(t2) || isNaN(tf) || !(0 < t1 && t1 < t2 && t2 < tf)) {
          e.preventDefault();
          if (err) { err.hidden = false; err.textContent = 'Czasy mm:ss muszą rosnąć: Pour 1 < Pour 2 < Koniec.'; }
          return;
        }
        if (!(bloomG < p1g && p1g <= water)) {
          e.preventDefault();
          if (err) { err.hidden = false; err.textContent = 'Gramy: Bloom < Pour 1 ≤ woda.'; }
          return;
        }
        if (err) err.hidden = true;
        const steps = '0:00|pour|' + bloomG + '|bloom\n' + p1t + '|pour|' + p1g + '|\n' + p2t + '|pour|' + water + '|\n' + fin + '|finish';
        const lines = [
          'BREW COMMUNITY — propozycja przepisu (do weryfikacji)',
          'Autor: ' + (($('#sWho') || {}).value || ''),
          'Instagram: ' + (($('#sIg') || {}).value || ''),
          'Nazwa: ' + (($('#sName') || {}).value || ''),
          'Metoda: ' + (($('#sMethod') || {}).value || ''),
          'Kawa handle: ' + (($('#sCoffee') || {}).value || ''),
          'Dawka: ' + (($('#sDose') || {}).value || '') + ' g',
          'Woda: ' + water + ' g',
          'Temperatura: ' + (($('#sTemp') || {}).value || '') + ' C',
          'Mielenie: ' + (($('#sGrind') || {}).value || ''),
          'Mlynek: ' + (($('#sGrinder') || {}).value || ''),
          'Ustawienie: ' + (($('#sSetting') || {}).value || ''),
          'Czas od: ' + (($('#sTmin') || {}).value || ''),
          'Czas do: ' + (($('#sTmax') || {}).value || ''),
          'Smak: ' + (($('#sTaste') || {}).value || ''),
          'Etapy (wklej do metaobject steps):',
          steps
        ];
        const body = $('#brewBody');
        if (body) body.value = lines.join('\n');
      });
    }

    renderPick();
    if (qs.get('start') === '1') openTimer();
    if (location.hash === '#submit-recipe' || qs.get('submit') === '1') {
      openSubmit(true);
      const el = $('#submit-recipe');
      if (el) el.scrollIntoView({ block: 'start' });
    }
  }

  init(document.querySelector('.vkb'));
  // Theme editor re-renders the section: initialise the fresh markup.
  document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.vkb')));
})();
